module.exports = __webpack_public_path__ + "media/stockholm/subway_model-7f3d6262.jpg";